/** Eight human participants total, including the caller and any requested interpreter. */
(function(root, factory) {
    const capacity = factory();
    if (typeof module === 'object' && module.exports) module.exports = capacity;
    else root.MalkaCallCapacity = capacity;
})(typeof globalThis !== 'undefined' ? globalThis : this, function() {
    const MAX_CALL_PARTICIPANTS = 8;
    // The composer's address rules (client-profile.js isHandleLike/isEmailLike).
    const HANDLE = /^@[a-z0-9_.-]{2,}$/i;
    const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    function maxInvitees(interpreterRequested) {
        return MAX_CALL_PARTICIPANTS - 1 - (interpreterRequested ? 1 : 0);
    }
    // Input order is selection order. Preserve the oldest selections.
    function fitParticipants(participants, interpreterRequested) {
        const limit = maxInvitees(interpreterRequested);
        return { participants: participants.slice(0, limit), removed: participants.slice(limit) };
    }
    function removalNote(removed, interpreterRequested) {
        if (!removed.length) return '';
        const names = removed.map(person => person.name || 'Last participant').join(', ');
        return interpreterRequested
            ? `${names} removed to leave room for the interpreter. Maximum 8 people, including you.`
            : `${names} removed. Maximum 8 people, including you.`;
    }
    /**
     * What a typed entry can be invited as: an @handle or an email, or null.
     * Names and numbers are not invitations: a name is a search, and a number
     * is placed with an interpreter.
     */
    function inviteTarget(text) {
        const value = String(text || '').trim();
        if (HANDLE.test(value)) return { handle: value };
        if (EMAIL.test(value)) return { email: value };
        return null;
    }
    function addressKey(value) {
        const text = String(value || '').trim();
        if (!text) return '';
        if (HANDLE.test(text)) return `handle:${text.slice(1).toLowerCase()}`;
        if (EMAIL.test(text)) return `email:${text.toLowerCase()}`;
        if (/[a-z@]/i.test(text)) return '';
        const digits = text.replace(/\D/g, '');
        if (digits.length < 7) return '';
        // A bare ten digits is NANP, as the dial preview reads it.
        return `phone:${!text.startsWith('+') && digits.length === 10 ? `1${digits}` : digits}`;
    }
    /**
     * Every identity that names this person: account, handle, email, number.
     * A saved contact and a recent call are two entries for one person; they
     * share at least one of these.
     */
    function participantKeys(participant) {
        const person = participant || {};
        const keys = [];
        const clientId = String(person.clientId || person.linkedClientId || '').trim();
        if (clientId) keys.push(`client:${clientId}`);
        [ person.target, person.handle, person.email, person.phone, person.phoneNumber ].forEach(value => {
            const key = addressKey(value);
            if (key && !keys.includes(key)) keys.push(key);
        });
        return keys;
    }
    function sameParticipant(a, b) {
        const keys = participantKeys(a);
        return participantKeys(b).some(key => keys.includes(key));
    }
    // First occurrence wins, so the order people were picked in is kept.
    function uniqueParticipants(participants) {
        return (participants || []).reduce((kept, person) =>
            kept.some(other => other === person || sameParticipant(other, person)) ? kept : [ ...kept, person ], []);
    }
    return {
        MAX_CALL_PARTICIPANTS,
        maxInvitees,
        fitParticipants,
        removalNote,
        inviteTarget,
        participantKeys,
        sameParticipant,
        uniqueParticipants
    };
});
